<template>

<v-app>

  <toolbar></toolbar>
  <member-item style="position: fixed; z-index: 100"
  :item-data='itemData' :item-ref='itemRef' :show-dialog='store.showDialog'></member-item>

<v-container class="pa-0 mt-2">
<v-row row>
<v-col xs12>
<v-list two-line>
  <!-- <template v-for="item in list" v-if="item.status === $route.query.status || $route.query === undefined"> -->
  <template v-for="item in list" v-if="item.status === $route.query.status || $route.query.status === undefined">
    <v-subheader v-if="item.header" v-text="item.header" />
    <v-divider v-else-if="item.divider" v-bind:inset="item.inset" />
    <v-list-item v-else v-bind:key="item.name">
      <!-- <v-list-tile avatar ripple @click.native.stop="editStaff(item)"> -->
      <v-list-tile avatar ripple @click.native.stop="show(item.ref)">
        <v-list-tile-avatar>
          <v-icon>account_circle</v-icon>
          <!-- <img v-bind:src="item.avatar" /> -->
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="item.name"/>
          <v-list-tile-sub-title v-html="item.readableStatus" />
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>
  </template>
</v-list>

</v-col>
</v-row>
</v-container>


</v-app>

</template>

<script>
// Firebase
import firebase from '../modules/firebase'
// Store
import store from '../modules/store'
// Locale
import locale from '../modules/locale'

// Components
import Toolbar from './Toolbar'
import MemberItem from './MemberItem'

export default {
  components: {
    'toolbar': Toolbar,
    'member-item': MemberItem
  },
  watch: {
    'showDialog': function () {
      if (this.showDialog === false) {
        // this.name = ''
        // this.description = ''
        // this.email = ''
        // this.ref = ''
      }
    }
    // 'removeConfirmation': function () {
    //   console.log(this.removeConfirmation)
    // }
  },
  data () {
    return {
      store,
      rootRef: 'members/users/',
      snackbar: false,
      removeConfirmation: false,
      showDialog: false,
      // email: '',
      // name: '',
      // description: '',
      // ref: '',
      error: {
        show: false,
        message: 'Name and Email are still empty.'
      },
      list: [],
      data: {},
      itemData: {},
      itemRef: ''
    }
  },
  methods: {
    removeStaff: function (item) {
      firebase.database().ref('users/').child(this.ref).remove()
      firebase.database().ref(this.rootRef).child(this.ref).remove()
      this.removeConfirmation = false
      this.showDialog = false
    },
    show: function (ref) {
      this.store.showDialog = true
      this.itemData = this.data[ref]
      this.itemRef = ref
    }
  },
  beforeMount: function () {
    this.$router.push({name: 'Main', query: {status: 'active'}})

    // firebase.database().ref(this.rootRef).on('value', (snapshot) => {
    firebase.database().ref(this.rootRef).orderByChild('requested').on('value', (snapshot) => {
      var data = snapshot.val()
      var list = []
      snapshot.forEach(function (snap) {
        // console.log(snap.val().name)
        list.unshift({
          avatar: '',
          name: snap.val().name,
          status: snap.val().status,
          readableStatus: locale.it.translate(snap.val().status),
          email: snap.val().email,
          ref: snap.key
        })
      })
      this.list = list
      this.data = data
    })
  },
  mounted: function () {
    // console.log(this.data)
  }
}
</script>



// WEBPACK FOOTER //
// Members.vue?01edda16